module.exports = __webpack_public_path__ + "img/settings-purple.d0c28d59.svg";